import loadable from '@loadable/component';

export const SharePage = loadable(/* #__LOADABLE__ */ () => import('./SharePage'));
